import React, { useState,useEffect } from 'react';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for redirection

const CreateAdmin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('');
    const navigate = useNavigate(); // For redirection
    const user = auth.currentUser; // Check for the current logged-in user
    useEffect(() => {
        if (!user) {
            navigate('/'); // If the user is not logged in, redirect to the login page
        }
    }, [user, navigate]);
    
    const handleCreateAdmin = async (e) => {
        e.preventDefault();
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            await set(ref(db, 'users/' + email.replace('.', ',')), {
                username,
                email: user.email,
                role: 'admin',
            });

            alert('Admin created successfully');
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <div>
            <h2>Create Admin</h2>
            <form onSubmit={handleCreateAdmin}>
                <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <button type="submit">Create Admin</button>
            </form>
        </div>
    );
};

export default CreateAdmin;
